export enum ResendMail {
    ACTIVE = 1,
   INACTIVE = 2
}


// WEBPACK FOOTER //
// ./src/app/customerservice/enums/resend-mail.enum.ts